import { TaskType } from "@common/types/task";
import { TaskTemplateAssigneeRole } from "@common/types/taskTemplate";
import {
    ASSIGNEE_ROLE_LABEL,
    ASSIGNEE_ROLE_OPTIONS,
    TASK_TYPE_LABEL,
} from "@components/settings/OrganizationCloseTemplates/closeTemplateTasksDrawer.constants";
import type {
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "../../FilterMultiselect/FilterMultiselect";

export const ORG_TASK_TEMPLATE_TYPE_OPTIONS: FilterMultiselectOption[] =
    Object.values(TaskType).flatMap((type) => {
        const label = TASK_TYPE_LABEL[type];
        return label ? [{ value: type, label, searchableLabel: label }] : [];
    });

export const ORG_TASK_TEMPLATE_ROLE_OPTIONS: FilterMultiselectOption[] =
    ASSIGNEE_ROLE_OPTIONS.map((role) => ({
        value: role,
        label: ASSIGNEE_ROLE_LABEL[role],
        searchableLabel: ASSIGNEE_ROLE_LABEL[role],
    }));

export const isTaskTypeValue = (
    value: FilterMultiselectValue,
): value is TaskType => Object.values(TaskType).some((type) => type === value);

export const isAssigneeRoleValue = (
    value: FilterMultiselectValue,
): value is TaskTemplateAssigneeRole =>
    ASSIGNEE_ROLE_OPTIONS.some((role) => role === value);

export const getTaskTypeLabel = (type: string): string =>
    (isTaskTypeValue(type) ? TASK_TYPE_LABEL[type] : undefined) ?? type;
